import { 
    IDI_DASHBOARD_START_LOADING, 
    IDI_DASHBOARD_END_LOADING,
    SET_IDI_DASHBOARD_FILTER_SEARCH,
    IDI_DASHBOARD_DRAFT_LOADED, 
    IDI_DASHBOARD_NEW_LOADED,
    IDI_DASHBOARD_DESIGN_REVIEW_LOADED,
    IDI_DASHBOARD_DESIGN_REVIEW_ACCEPTED_LOADED,
    IDI_DASHBOARD_DESIGN_REVIEW_REJECTED_LOADED,
    IDI_DASHBOARD_UPLOADED_TO_BALADY_LOADED,
    IDI_DASHBOARD_FOUNDATION_LOADED,
    IDI_DASHBOARD_GROUND_BEAM_LOADED,
    IDI_DASHBOARD_COLUMNS_LOADED,
    IDI_DASHBOARD_SLAB_LOADED,
    IDI_DASHBOARD_WATER_PROOFING_LOADED,
    IDI_DASHBOARD_FINISHES_LOADED,
    IDI_DASHBOARD_PROJECT_COMPLETION_LOADED,
    IDI_DASHBOARD_COMPLETED_LOADED,
    IDI_DASHBOARD_CLOSED_LOADED,
    IDI_DASHBOARD_CANCELLED_LOADED,
    IDI_DASHBOARD_ABORTED_LOADED,
    IDI_DASHBOARD_USER_SEARCH_LOADED
} from "../constants/IdiDashboardConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIdiDashboard(status, search) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_DASHBOARD_START_LOADING });

        try {

            var data = await getApiData("IdiProject/GetIdiProjectGroupFBO", { status, search }, null);
            
            if(data.success) {
                if(status === null || status === "" || status === "Draft") {
                    await dispatch({
                        type: IDI_DASHBOARD_DRAFT_LOADED,
                        payload: data.responseEntities[0].draftList
                    });
                }

                if(status === null || status === "" || status === "New") {
                    await dispatch({
                        type: IDI_DASHBOARD_NEW_LOADED,
                        payload: data.responseEntities[0].newList
                    });
                }

                if(status === null || status === "" || status === "Design Review") {
                    await dispatch({
                        type: IDI_DASHBOARD_DESIGN_REVIEW_LOADED,
                        payload: data.responseEntities[0].designReviewList
                    });
                }

                if(status === null || status === "" || status === "Design Review Accepted") {
                    await dispatch({
                        type: IDI_DASHBOARD_DESIGN_REVIEW_ACCEPTED_LOADED,
                        payload: data.responseEntities[0].designReviewAcceptedList
                    });
                }

                if(status === null || status === "" || status === "Design Review Rejected") {
                    await dispatch({
                        type: IDI_DASHBOARD_DESIGN_REVIEW_REJECTED_LOADED,
                        payload: data.responseEntities[0].designReviewRejectedList
                    });
                }

                if(status === null || status === "" || status === "Uploaded to Balady") {
                    await dispatch({
                        type: IDI_DASHBOARD_UPLOADED_TO_BALADY_LOADED,
                        payload: data.responseEntities[0].uploadedToBaladyList
                    });
                }

                if(status === null || status === "" || status === "Foundation") {
                    await dispatch({
                        type: IDI_DASHBOARD_FOUNDATION_LOADED,
                        payload: data.responseEntities[0].foundationList
                    });
                }

                if(status === null || status === "" || status === "Ground Beam") {
                    await dispatch({
                        type: IDI_DASHBOARD_GROUND_BEAM_LOADED,
                        payload: data.responseEntities[0].groundBeamList
                    });
                }

                if(status === null || status === "" || status === "Columns") {
                    await dispatch({
                        type: IDI_DASHBOARD_COLUMNS_LOADED,
                        payload: data.responseEntities[0].columnsList
                    });
                }

                if(status === null || status === "" || status === "Slab") {
                    await dispatch({
                        type: IDI_DASHBOARD_SLAB_LOADED,
                        payload: data.responseEntities[0].slabList
                    });
                }

                if(status === null || status === "" || status === "Waterproofing") {
                    await dispatch({
                        type: IDI_DASHBOARD_WATER_PROOFING_LOADED,
                        payload: data.responseEntities[0].waterproofingList
                    });
                }

                if(status === null || status === "" || status === "Finishes") {
                    await dispatch({
                        type: IDI_DASHBOARD_FINISHES_LOADED,
                        payload: data.responseEntities[0].finishesList
                    });
                }

                if(status === null || status === "" || status === "Project Completion") {
                    await dispatch({
                        type: IDI_DASHBOARD_PROJECT_COMPLETION_LOADED,
                        payload: data.responseEntities[0].projectCompletionList
                    });
                }

                if(status === null || status === "" || status === "Completed") {
                    await dispatch({
                        type: IDI_DASHBOARD_COMPLETED_LOADED,
                        payload: data.responseEntities[0].completedList
                    });
                }

                if(status === null || status === "" || status === "Closed") {
                    await dispatch({
                        type: IDI_DASHBOARD_CLOSED_LOADED,
                        payload: data.responseEntities[0].closedList
                    });
                }

                if(status === null || status === "" || status === "Cancelled") {
                    await dispatch({
                        type: IDI_DASHBOARD_CANCELLED_LOADED,
                        payload: data.responseEntities[0].cancelledList
                    });
                }

                if(status === null || status === "" || status === "Aborted") {
                    await dispatch({
                        type: IDI_DASHBOARD_ABORTED_LOADED,
                        payload: data.responseEntities[0].abortedList
                    });
                }

                await dispatch({
                    type: IDI_DASHBOARD_USER_SEARCH_LOADED,
                    payload: data.responseEntities[0].userSearches
                });
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: IDI_DASHBOARD_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_DASHBOARD_END_LOADING });
        }
    };
}

export function setIdiDashboardFilterSearch(search) {
    return async (dispatch) => {
        await dispatch({
            type: SET_IDI_DASHBOARD_FILTER_SEARCH,
            payload: search
        });
    };
}

export function assignIdiProject(idiProjectId, userId, assignMe, items, index) {
    return async (dispatch) => {
        
        await dispatch({ type: IDI_DASHBOARD_START_LOADING });

        try {

            var data = await postApiJsonData("IdiProject/AssignIdiProject", { idiProjectId, userId, assignMe }, null);
            
            if(data.success) {
                if(data.responseEntities[0].status === "Design Review") {
                    items[index] = data.responseEntities[0];

                    await dispatch({
                        type: IDI_DASHBOARD_NEW_LOADED,
                        payload: items
                    });
                }
            }
            else {
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
            await dispatch({ type: IDI_DASHBOARD_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: IDI_DASHBOARD_END_LOADING });
        }
    };
}